import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["belowTopResult", "items", "positionOffset"];
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { useState } from 'react';
import { RecommendationsListActivityProvider, useIsRecommendationsListActive } from './RecommendationsListActivity';
export const TopResultSplitList = _ref => {
  let belowTopResult = _ref.belowTopResult,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$positionOffset = _ref.positionOffset,
    positionOffset = _ref$positionOffset === void 0 ? 0 : _ref$positionOffset,
    listProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const SearchRecommendationList = DomainSearchSuiteModule.SDK.Components.SearchRecommendationList;
  const isListActive = useIsRecommendationsListActive();
  const _useState = useState('top'),
    activeSegment = _useState[0],
    setActiveSegment = _useState[1];
  if (!belowTopResult || items.length === 0) {
    return /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
      items: items,
      positionOffset: positionOffset
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationsListActivityProvider, {
    value: isListActive && activeSegment === 'top'
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setActiveSegment('top')
  }, /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
    items: items.slice(0, 1),
    positionOffset: positionOffset,
    hasActiveRow: activeSegment === 'top'
  })))), belowTopResult, /*#__PURE__*/React.createElement(RecommendationsListActivityProvider, {
    value: isListActive && activeSegment === 'rest'
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setActiveSegment('rest')
  }, /*#__PURE__*/React.createElement(SearchRecommendationList, _extends({}, listProps, {
    items: items.slice(1),
    positionOffset: positionOffset + 1,
    firstSuggestionPrimary: false,
    hasActiveRow: activeSegment === 'rest'
  })))));
};
//# sourceMappingURL=TopResultSplitList.js.map